var _defs, _rect, _rect2, _rect3, _rect4, _circle, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cadLogoBg",
    x1: 14,
    y1: 12,
    x2: 82,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E7C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cadLogoGlow",
    x1: 56,
    y1: 20,
    x2: 80,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5EFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97F4F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 84,
    height: 84,
    rx: 26,
    fill: "url(#cadLogoBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#FFF8EE",
    fillOpacity: 0.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 44,
    height: 8,
    rx: 4,
    fill: "#FFF8EE",
    fillOpacity: 0.88
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 56,
    width: 34,
    height: 8,
    rx: 4,
    fill: "#FFF8EE",
    fillOpacity: 0.82
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 33,
    r: 11,
    stroke: "#FFF8EE",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 41.5L77 50",
    stroke: "#FFF8EE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 33,
    r: 4,
    fill: "url(#cadLogoGlow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadLogo);
export default __webpack_public_path__ + "static/media/cad-logo.c81c87bfbe3d274a7db5002f6941dbe6.svg";
export { ForwardRef as ReactComponent };